import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'

const AllowListModal = ({ allowList, setAllowList }) => {
    return (
        <div>
            <Transition.Root show={allowList} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setAllowList}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#c1c9d2b3]" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md">
                                    <div>
                                        <div className="font-semibold sm:p-[16px_20px] p-[16px] border-b-[1px] border-[#ebeef1] text-base text-gray-900">Add to allow list?</div>
                                        <div className="sm:p-[16px_20px] p-[16px] border-b-[1px] border-[#ebeef1]">
                                            <p className='text-sm text-[#414552]'>If you add a customer to an allow list, they can’t be blocked by a Radar rule.</p>
                                        </div>
                                        <div className="font-semibold sm:p-[16px_20px] p-[16px] flex justify-end text-base text-gray-900 gap-2">
                                            <button className="input_focus_shadow h-[30px] rounded-[6px] text-[14px] font-semibold p-[0_8px]" onClick={() => setAllowList(false)}>Cancel</button>
                                            <button className="h-[30px] rounded-[6px] text-white bg-[#625afa] text-[14px] font-semibold p-[0_8px]">Add</button>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </div>
    )
}

export default AllowListModal